(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-product-description"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-auto-product-description]';
    const clean = (value) => value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    const cleanListMarker = (value) => clean(value).replace(/^[•·▪◦–—-]\s*/, '');
    const headingPattern = /^(списък|фабрично оборудване|оборудване|екстериор|интериор|комфорт|мултимедия|сигурност|безопасност|асистенти|двигател|трансмисия|допълнително)(\s*:)?$/i;
    const codePattern = /^[A-Z0-9]{3,4}\s*-\s+/;
    const inlineCodePattern = /(^|\s)([A-Z0-9]{3,4}\s*-\s+)/g;

    const paragraphParts = (node) => {
      const holder = document.createElement('div');
      holder.innerHTML = node.innerHTML.replace(/<br\s*\/?\s*>/gi, '\n');
      const raw = holder.textContent.replace(/\r/g, '\n');
      let parts = raw.split(/\n+/).map(clean).filter(Boolean);
      if (parts.length === 1) {
        const coded = raw
          .replace(inlineCodePattern, '$1\n$2')
          .split(/\n+/)
          .map(clean)
          .filter(Boolean);
        if (coded.length > 1) parts = coded;
      }
      return parts;
    };

    const formatDescription = (root) => {
      if (root.dataset.autoFormatted === 'true') return;
      root.dataset.autoFormatted = 'true';

      const children = [...root.children];
      const paragraphs = children.filter((node) => node.tagName === 'P');
      const duplicates = new Set();

      paragraphs.forEach((node, index) => {
        const text = clean(node.textContent);
        const later = clean(paragraphs.slice(index + 1).map((item) => item.textContent).join(' '));
        if (text.length > 180 && later.startsWith(text)) duplicates.add(node);
      });

      const units = [];
      children.forEach((node) => {
        if (duplicates.has(node)) return;
        if (/^H[2-6]$/.test(node.tagName)) {
          const text = clean(node.textContent);
          if (text) units.push({ text, kind: 'heading' });
          return;
        }
        if (node.tagName === 'UL' || node.tagName === 'OL') {
          [...node.querySelectorAll(':scope > li')].forEach((item) => {
            const text = cleanListMarker(item.textContent);
            if (text) units.push({ text, kind: 'item' });
          });
          return;
        }
        if (node.tagName === 'P') {
          const parts = paragraphParts(node);
          parts.forEach((text) => {
            const normalized = parts.length > 1 ? cleanListMarker(text) : text;
            if (normalized) units.push({ text: normalized, kind: parts.length > 1 ? 'split' : 'paragraph' });
          });
          return;
        }
        const text = clean(node.textContent);
        if (text) units.push({ text, kind: 'paragraph' });
      });

      const seen = new Set();
      const unique = units.filter((unit) => {
        const key = clean(unit.text).toLocaleLowerCase('bg');
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      const fragment = document.createDocumentFragment();
      let list = null;
      let leadRendered = false;

      const addItem = (text) => {
        if (!list) {
          list = document.createElement('ul');
          list.className = 'original-description-list';
          fragment.append(list);
        }
        const item = document.createElement('li');
        item.textContent = text;
        list.append(item);
      };

      const endList = () => {
        list = null;
      };

      unique.forEach((unit) => {
        const isHeading = unit.kind === 'heading' || headingPattern.test(unit.text) || (unit.text.endsWith(':') && unit.text.length < 90);
        if (isHeading) {
          endList();
          const heading = document.createElement('h3');
          heading.className = 'product-description-heading';
          heading.textContent = unit.text.replace(/:\s*$/, '');
          fragment.append(heading);
          return;
        }

        const coded = codePattern.test(unit.text);
        const sentenceCount = (unit.text.match(/[.!?](?:\s|$)/g) || []).length;
        const isLead = !leadRendered && !coded && unit.text.length >= 120;
        if (isLead) {
          endList();
          const lead = document.createElement('p');
          lead.className = 'product-description-lead';
          lead.textContent = unit.text;
          fragment.append(lead);
          leadRendered = true;
          return;
        }

        const isSplitItem = unit.kind === 'split' && (coded || (unit.text.length <= 260 && sentenceCount <= 1));
        const isItem = unit.kind === 'item' || isSplitItem || coded || (unit.text.length <= 220 && sentenceCount <= 1);
        if (isItem) {
          addItem(unit.text);
          return;
        }

        endList();
        const paragraph = document.createElement('p');
        paragraph.className = 'product-description-paragraph';
        paragraph.textContent = unit.text;
        fragment.append(paragraph);
      });

      root.replaceChildren(fragment);
    };

    const boot = (scope = document) => {
      scope.querySelectorAll(selector).forEach(formatDescription);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
